import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as labsComponents from 'vuetify/labs/components'
import defaults from './defaults'
import { icons } from './icons'
import theme from './theme'

// Styles
import '@core/scss/template/libs/vuetify/index.scss'
import 'vuetify/styles'

export default createVuetify({
  components: {
    ...components,
    ...labsComponents,
  },
  aliases: {
    IconBtn: components.VBtn,
  },
  defaults,
  icons,
  theme,
})
